import * as Sentry from '@sentry/react';
import { History } from 'history';

export const initializeSentry = (
  dsn: string | undefined,
  environment: string,
  version: string | undefined,
  history: History
) => {
  if (!dsn || environment === 'local') {
    return;
  }

  Sentry.init({
    dsn,
    environment: environment,
    release: version,

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,

    // https://docs.sentry.io/platforms/javascript/guides/react/best-practices/offline-caching/
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),

    integrations: [
      // https://docs.sentry.io/platforms/javascript/guides/react/logs/
      Sentry.consoleLoggingIntegration({
        levels: ['error']
      }),

      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/httpclient/
      Sentry.httpClientIntegration(),

      // https://docs.sentry.io/platforms/javascript/guides/react/tracing/
      Sentry.reactRouterV5BrowserTracingIntegration({ history }),

      // https://docs.sentry.io/platforms/javascript/guides/react/session-replay/
      Sentry.replayIntegration({
        stickySession: true,
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false
      })
    ],

    // Navigation and payload spans generated by route changes using components from react-router-dom-v5-compat are not
    // automatically written a correct description. This happens because we're still mainly using react-router-dom v5
    // and the Sentry.reactRouterV5BrowserTracingIntegration() integration. This is a workaround to fix this limitation.
    beforeSendSpan: (span) => {
      if (span.op === 'navigation' || span.op === 'pageload') {
        span.description = window.location.pathname;
      }

      return span;
    },

    tracesSampleRate: 1.0,

    enableLogs: true,

    // No replay sessions will be recorded unless an error occurs
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
  });
};